/**
 * Floating emoji bubble overlay.
 *
 * Renders active emoji messages as floating bubbles on the game screen.
 * Each bubble shows the emoji + sender name and fades out after 3 seconds.
 */

import type { EmojiMessageEvent } from "../types";

const BUBBLE_TOP_OFFSET = 12;
const BUBBLE_VERTICAL_SPACING = 56;

interface EmojiMessageOverlayProps {
  readonly messages: ReadonlyArray<EmojiMessageEvent>;
}

export function EmojiMessageOverlay({ messages }: EmojiMessageOverlayProps) {
  if (messages.length === 0) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 20,
        overflow: "hidden",
      }}
    >
      {messages.map((msg, index) => (
        <div
          key={msg.id}
          style={{
            position: "absolute",
            top: `${BUBBLE_TOP_OFFSET + index * BUBBLE_VERTICAL_SPACING}px`,
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "2px",
            padding: "6px 12px",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            animation: "emoji-fade-in 0.2s ease-out",
          }}
        >
          <span style={{ fontSize: "28px", lineHeight: 1 }}>{msg.emoji}</span>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 600,
              color: "#888",
              whiteSpace: "nowrap",
            }}
          >
            {msg.displayName}
          </span>
        </div>
      ))}
    </div>
  );
}
